/** @format */
// @ts-ignore there are no types for normalize
import { css } from 'styled-components';
import reset from 'styled-normalize';

/**
 * The global styles for Toucan
 * */
export const globalStyles = css`
    ${reset}

    :root {
        --header-height: 0px;

        --z-index-jump-links: 8;
        --z-index-intercom: 9;
        --z-index-sticky-footer: 16;
        --z-index-mobile-typeahead-suggestions: 17;
        --z-index-tray: 9999;
    }

    html {
        box-sizing: border-box;
        font-size: 62.5%;
        height: 100%;
        scroll-behavior: smooth;
        background-color: var(--colors-surface-secondary);

        *,
        *:before,
        *:after {
            box-sizing: inherit;
        }
    }

    body {
        font-family: var(--typography-font);
        color: var(--colors-text-primary);
        font-size: var(--typography-font-size-base);
        font-style: normal;
        font-weight: var(--typography-weight-regular);
        line-height: var(--typography-line-height-snug);
        letter-spacing: var(--typography-letter-spacing-tight);
        height: 100%;
    }

    p {
        margin: 0 0 1.5em;

        &:last-child,
        &:last-of-type {
            margin: 0;
        }
    }

    ul,
    ol {
        padding-left: 2rem;
    }

    img {
        max-width: 100%;
    }

    hr {
        margin: var(--layout-spacing-48) 0;
        border: none;
        height: 1px;
        background-color: var(--colors-surface-tertiary);
    }

    /* We need to set the react root height, 
       Unable to hook into the next root to define this style see https://github.com/vercel/next.js/issues/4834
     */
    #__next {
        height: 100%;
    }
`;
